module.exports = __webpack_public_path__ + "img/areadevelop_icon.f49c75d5.png";